/*---------------------------
	Custom site scripts
----------------------------*/

jQuery(document).ready(function($){
	
	// SVG Animation map
	if ($("#sticky-header").length) {
		var waypoint = new Waypoint({
			element: $('body'),
			handler: function(direction) {
				if (direction === 'down') {
					$('#sticky-header').addClass('header-sticky');
				} else if (direction === 'up') {
					$('#sticky-header').removeClass('header-sticky');
				}
			},offset: -300
		  })
	}
	
	// Setup mega menus
	$('#site-header li.menu-item-has-children').on('mouseover', function(){
		
		var current = $(this);
		var subMenu = $('> .sub-menu', current).html();
		var MenuLabel = $('> a', current).html();
		
		$('#mega-menu .right ul').html(subMenu);
		$('#mega-menu .right h3').html(MenuLabel);
		$('#mega-menu').addClass('show');
		
	});
	
	$('#site-header li.menu-item-has-children, #mega-menu').on('mouseout', function(){
			
		$('#mega-menu').removeClass('show');
		
	});
	
	$('#mega-menu').on('mouseover', function(){
				
		$('#mega-menu').addClass('show');
		
	});
	
	$(window).on('resize', setMegaMenuTop);
	
	setMegaMenuTop();
	
});

function setMegaMenuTop() {
	
	var mainMenuItem = jQuery('#site-header .menu-item-has-children');
	var offset = mainMenuItem.offset().top + mainMenuItem.height() - 6;
	
	jQuery('#mega-menu').css('top', offset);
	
}
